import store from "@/store"
import { DetailSchemaItem } from "../product/components/part-detail/constant"
import { STATUS_OPTIONS } from "../product/constant"

export const categories = [
    {
        label: "文生文",
        prop: 1,
        value: 1
    },
    {
        label: "文生图",
        prop: 2,
        value: 2
    },
    {
        label: "图生文",
        prop: 3,
        value: 3
    },
    {
        label: "图生图",
        prop: 4,
        value: 4
    },
    {
        label: "其他",
        prop: 5,
        value: 5
    }
]
export const model_tag = [
    {
        label: "自研模型",
        value: 1
    },
    {
        label: "第三方已备案模型",
        value: 2
    }
]

export const unique_visitor = [
    {
        label: "10万以内",
        value: 1
    },
    {
        label: "10万-100万",
        value: 2
    },
    {
        label: "100万以上",
        value: 3
    }
]
export const scope = [
    {
        label: "独立应用",
        value: 1
    },
    {
        label: "产品功能",
        value: 2
    }
]
export const getColumns = (context: any) => {
    return [
        {
            title: "功能名称",
            dataIndex: "title",
            width: 250,
            renderProps: {
                onClick: (e: any) => {
                    context.onView([e])
                }
            },
            filter: {
                type: "input"
            },
            renderType: "link"
        },
        {
            title: "功能类型",
            dataIndex: "category",
            width: 160,
            filter: {
                type: "select",
                mode: "multiple",
                options: categories
            }
        },
        {
            title: "功能范围",
            dataIndex: "scope",
            width: 150,
            filter: {
                type: "select",
                options: scope
            },
            customRender: (text: number) => {
                return scope?.find((t: any) => t.value == text)?.label || "-"
            }
        },
        {
            title: "用户规模",
            dataIndex: "unique_visitor",
            width: 150,
            filter: {
                type: "select",
                options: unique_visitor
            },
            customRender: (text: number) => {
                return unique_visitor?.find((t: any) => t.value == text)?.label || "-"
            }
        },
        {
            title: "产品名称",
            dataIndex: "product_name",
            filter: {
                type: "select",
                options: context.visible_products
            },
            width: 150
        },
        {
            title: "上架平台",
            dataIndex: "sub_type",
            width: 150,
            filter: {
                type: "select",
                mode: "multiple",
                options: context.product_sub_type
            }
        },
        {
            title: "产品线",
            dataIndex: "software_name",
            width: 150
        },
        {
            title: "事业部",
            dataIndex: "dept",
            width: 150,
            filter: {
                type: "select",
                options: context.top_dept
            }
        },
        {
            title: "业务开展区域",
            dataIndex: "business_area",
            width: 150,
            filter: {
                type: "select",
                options: context.business_area
            },
            customRender: (text: number) => {
                return context.business_area?.find((t: any) => t.value == text)?.label || "-"
            }
        },
        {
            title: "模型类型",
            dataIndex: "model_types",
            width: 150,
            filter: {
                type: "select",
                mode: "multiple",
                options: model_tag
            }
        },
        {
            title: "状态",
            dataIndex: "status",
            width: 100,
            filter: {
                type: "select",
                mode: "multiple",
                options: STATUS_OPTIONS.map(e => ({
                    ...e,
                    value: String(e.value) // 解决pub-ui中将0视为无的问题
                }))
            },
            renderType: "status",
            renderProps: {
                zeroIsNull: false,
                options: STATUS_OPTIONS
            }
        },
        {
            title: "上架时间",
            dataIndex: "up_time",
            width: 150,
            renderType: "date",
            renderProps: {
                format: "YYYY-MM-DD HH:mm:ss"
            }
        }
    ]
}

// 详情
export const BasicInfo = [
    {
        label: "功能名称",
        dataIndex: "title",
        span: 1
    },
    {
        label: "功能类型",
        dataIndex: "category",
        customRender: (text: any) => categories.find((t: any) => t.value === text)?.label || "-",
        span: 1
    },
    {
        label: "功能范围",
        dataIndex: "scope",
        customRender: (text: any) => scope.find((t: any) => t.value === text)?.label || "-",
        span: 1
    },
    {
        label: "用户规模",
        dataIndex: "unique_visitor",
        customRender: (text: any) => unique_visitor.find((t: any) => t.value === text)?.label,
        span: 1
    },
    {
        label: "产品名称",
        dataIndex: "product_name",
        span: 1
    },
    {
        label: "上架平台",
        dataIndex: "sub_type",
        customRender: (text: any) =>
            store.state.common.product_sub_type.find((t: any) => t.value === text)?.label || "-",
        span: 1
    },
    {
        label: "产品线",
        dataIndex: "software_name",
        span: 1
    },
    {
        label: "事业部",
        dataIndex: "dept",
        renderType: "dept",
        span: 1
    },
    {
        label: "业务开展区域",
        dataIndex: "business_area",
        customRender: (text: any) =>
            store.state.common.business_area.find((t: any) => t.value === text)?.label || "-",
        span: 1
    },
    {
        label: "状态",
        dataIndex: "status",
        span: 1
    },
    {
        label: "上架时间",
        dataIndex: "up_time",
        span: 1
    },
    {
        label: "访问路径",
        dataIndex: "access_path",
        renderType: "a-textarea",
        span: 1
    },
    {
        label: "内容安全接入方式",
        dataIndex: "content_security_mode",
        renderType: "a-textarea",
        span: 1
    },
    {
        label: "安全测试报告",
        dataIndex: "security_test",
        renderType: "link",
        span: 1
    }
]
// 详情：备案信息--算法
export const AlgorithmBasicInfo: DetailSchemaItem[] = [
    {
        label: "算法名称",
        dataIndex: "title",
        span: 1
    },
    {
        label: "算法类别",
        dataIndex: "sub_type",
        span: 1
    },
    {
        label: "算法备案号",
        dataIndex: "icp_no",
        span: 1
    }
]
// 详情：备案信息--第三方
export const ThirdPartyBasicInfo: DetailSchemaItem[] = [
    {
        label: "模型名称",
        dataIndex: "title",
        span: 1
    },
    {
        label: "模型版本",
        dataIndex: "sub_type",
        span: 1
    },
    {
        label: "备案号",
        dataIndex: "icp_no",
        span: 1
    }
]
// 详情 tab2 表格
export const DetailTab2Columns = [
    {
        title: "操作名称",
        dataIndex: "record_name",
        key: "record_name"
    },
    {
        title: "操作人",
        dataIndex: "operate_user_uid",
        key: "operate_user_uid",
        scopedSlots: { customRender: "operate_user_uid" }
    },
    {
        title: "操作时间",
        dataIndex: "operate_time",
        key: "operate_time"
    },
    {
        title: "操作详情",
        dataIndex: "details",
        key: "details",
        ellipsis: true,
        scopedSlots: { customRender: "details" }
    }
]
